import { useCallback } from "react";
import { eliminarProducto } from "../../../services/backend/cotizacionService";

const useCartItemRemoval = ({ cartItems, loadCotizacionFromBackend, selectedAlmacen, toastRef }) => {

  const handleRemoveItem = useCallback(async (lineKey) => {
    const item = cartItems.find((it) => it.lineKey === lineKey);
    const backendDetailId = item?.backendDetailId || null;

    if (!backendDetailId) {
      toastRef.current?.show({
        severity: "error",
        summary: "No se puede eliminar",
        detail: "No se puede eliminar este producto (sin detalle backend).",
        life: 3200,
      });
      return;
    }

    try {
      await eliminarProducto(backendDetailId);
      await loadCotizacionFromBackend(selectedAlmacen);
      toastRef.current?.show({
        severity: "success",
        summary: "Producto eliminado",
        detail: "Se eliminó el producto de la cotización.",
        life: 2200,
      });
    } catch (error) {
      toastRef.current?.show({
        severity: "error",
        summary: "No se pudo eliminar",
        detail: error?.message || "Error al eliminar producto de la cotización.",
        life: 3200,
      });
    }
  }, [cartItems, loadCotizacionFromBackend, selectedAlmacen, toastRef]);

  return { handleRemoveItem };
};

export default useCartItemRemoval;
